import ToolTipContent from '../ToolTipContent';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

interface company_attributes {
  company_attributes: {
    title: string;
    description?: string;
    color: string;
  };
}
const CompanyLabelDot: React.FC<company_attributes> = ({
  company_attributes
}) => {
  return (
    <ToolTipContent
      tooltip
      text={company_attributes.description || company_attributes.title}
    >
      <FiberManualRecordIcon sx={{ color: company_attributes.color }} />
    </ToolTipContent>
  );
};

export default CompanyLabelDot;
